// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/assistenza/kb',
    requestBody: null,
    response: '{ success: true, data: [{ slug, titolo, riassunto, moduli, aggiornato, attivo, generato, syncAt }] }'
  },
  {
    method: 'GET',
    endpoint: '/api/assistenza/kb/:slug',
    requestBody: null,
    response: '{ success: true, data: { slug, titolo, riassunto, moduli, aggiornato, attivo, generato, syncAt, contenuto } }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
